module.exports = __webpack_public_path__ + "img/biaozhun-card.1641cf13.svg";